/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Type_TvInputs */



/**
* | output |
* | --- |
* | "TV Parental Guideline" |
*
* @param {Subtitle_Export_Vchip_Type_TvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_type_tv = /** @type {((inputs?: Subtitle_Export_Vchip_Type_TvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Type_TvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recommandations parentales pour la télévision")
	if (locale === "de") return /** @type {LocalizedString} */ ("TV-Elternrichtlinien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linee guida per i genitori in TV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Рекомендации для родителей по просмотру телепередач")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía para padres sobre televisión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电视节目家长指导")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テレビのペアレンタルガイドライン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीवी अभिभावक दिशानिर्देश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diretrizes parentais para TV")
	return /** @type {LocalizedString} */ ("TV Parental Guideline")
});